import React, { useState, useEffect } from 'react';
import {
  ParentAccountInfo,
  StudentAccountInfo,
} from '@projectK/modules/MyProfile';
import { Box } from '@mui/material';
import jwtAxios from '@projectK/services/auth/JWT';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import AppCard from '@projectK/components/AppCard';
import CommonAccountInfo from './CommonAccountInfo';
import {isStudent,isParent,hasPermission, useRolePermissions } from '@projectK/context/RolesProvider';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';

const AccountInfoBlock = (
  user,
  settings,
  fetchData,
  isMobile,
  mobileMode,
  rolePermissions,
  roleData,
) => {
  let account = hasPermission(rolePermissions, 'My Locker - Account Info', 'read') ? (
    <CommonAccountInfo settings={settings} fetchData={fetchData} />
  ) : null;
  
  if (isParent(user)) {
    account = (
      <ParentAccountInfo
        settings={settings}
        fetchData={fetchData}
        isMobile={isMobile}
        mobileMode={mobileMode}
        rolePermissions={rolePermissions}
        hasPermission={hasPermission}
      />
    );
  } else if (isStudent(user)) {
    account = (
      <StudentAccountInfo
        settings={settings}
        fetchData={fetchData}
        isMobile={isMobile}
        rolePermissions={rolePermissions}
        hasPermission={hasPermission}
        roleData={roleData}
      />
    );
  }
  return account;
};

const AccountInfo = () => {
  const { user } = useAuthUser();
  const [settings, setSettings] = useState(null);
  const { isMobile, mobileMode } = useMobileSettings();
  const [userMembers, setUserMembers] = useState(null);
  const { rolePermissions, roleData } = useRolePermissions();
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const userResponse = await jwtAxios.get(`/users/${user?.id}`);
      if (isParent(user)) {
        const response = await jwtAxios.get(`/user-members/${user?.id}`, {
          params: {
            perPage: 'all',
          },
        });
        const { data } = response;
        setUserMembers(data?.list);
      }
      setSettings(userResponse.data);
    } catch (error) {
      // Handle error
      console.error('Error fetching appearance settings:', error);
    }
  };

  return (
    <Box
      className={isMobile ? 'mobile-account-info' : ''}
      style={isMobile ? { marginBottom: '50px' } : {}}
    >
      {settings ? (
        AccountInfoBlock(
          user,
          settings,
          fetchData,
          isMobile,
          mobileMode,
          rolePermissions,
          roleData
        )
      ) : (
        <p>Loading settings...</p>
      )}
      <AppCard sx={{ marginTop: '20px' }}>
        {isParent(user) && userMembers ? (
          <>
            {userMembers.map((data) => (
              <StudentAccountInfo
                key={data?.id}
                studentId={data?.id}
                settings={data}
                fetchData={fetchData}
                rolePermissions={rolePermissions}
                hasPermission={hasPermission}
                roleData={roleData}
              />
            ))}
          </>
        ) : null}
      </AppCard>
    </Box>
  );
};

export default AccountInfo;
